import { render, staticRenderFns } from "./VenuesList.vue?vue&type=template&id=0ad9f7e0&scoped=true"
import script from "./VenuesList.vue?vue&type=script&lang=ts"
export * from "./VenuesList.vue?vue&type=script&lang=ts"
import style0 from "./VenuesList.vue?vue&type=style&index=0&id=0ad9f7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad9f7e0",
  null
  
)

export default component.exports